"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.KmsTimeoutError = exports.KmsError = exports.DryError = void 0;

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _apply = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/apply"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _common = require("@webex/common");

var _webexCore = require("@webex/webex-core");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Error class for KMS errors
 */
var KmsError = /*#__PURE__*/function (_Exception) {
  (0, _inherits2.default)(KmsError, _Exception);

  var _super = _createSuper(KmsError);

  function KmsError() {
    (0, _classCallCheck2.default)(this, KmsError);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(KmsError, [{
    key: "parse",
    value:
    /**
     * @param {HttpResponse} body
     * @returns {string}
     */
    function parse(body) {
      body = body.body || body;
      (0, _defineProperties.default)(this, {
        body: {
          enumerable: false,
          value: body
        },
        reason: {
          enumerable: false,
          value: body.reason
        },
        requestId: {
          enumerable: false,
          value: body.requestId
        },
        status: {
          enumerable: false,
          value: body.status
        }
      });
      var message = typeof body === 'string' ? body : body.reason;

      if (!message) {
        message = this.constructor.defaultMessage;
      }

      if (body.status) {
        message += "\nKMS_RESPONSE_STATUS: ".concat(body.status);
      }

      if (body.requestId) {
        message += "\nKMS_REQUEST_ID: ".concat(body.requestId);
      }

      return message;
    }
  }]);
  return KmsError;
}(_common.Exception);
/**
 * Thrown when an expected KMSResponse is not received in a timely manner
 */


exports.KmsError = KmsError;
(0, _defineProperty2.default)(KmsError, "defaultMessage", 'An unknown error occurred while communicating with the kms. This implies we received an error response without a body.');

var KmsTimeoutError = /*#__PURE__*/function (_KmsError) {
  (0, _inherits2.default)(KmsTimeoutError, _KmsError);

  var _super2 = _createSuper(KmsTimeoutError);

  function KmsTimeoutError() {
    (0, _classCallCheck2.default)(this, KmsTimeoutError);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(KmsTimeoutError, [{
    key: "parse",
    value:
    /**
     * @param {KmsRequest} options.request
     * @param {KmsRequest} options.timeout
     * @returns {string}
     */
    function parse() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$request = _ref.request,
          request = _ref$request === void 0 ? {} : _ref$request,
          timeout = _ref.timeout;

      var message = "The KMS did not respond within ".concat(timeout ? "".concat(timeout, " milliseconds") : 'a timely fashion');

      if (request) {
        if (request.method && request.uri) {
          message += "\nKMS_REQUEST: ".concat(request.method, " ").concat(request.uri);
        }

        if (request.requestId) {
          message += "\nKMS_REQUEST_ID: ".concat(request.requestId);
        }
      }

      return message;
    }
  }]);
  return KmsTimeoutError;
}(KmsError);
/**
 * Emitted when a REST request includes an encrypter error
 */


exports.KmsTimeoutError = KmsTimeoutError;

var DryError = /*#__PURE__*/function (_WebexHttpError) {
  (0, _inherits2.default)(DryError, _WebexHttpError);

  var _super3 = _createSuper(DryError);

  function DryError() {
    (0, _classCallCheck2.default)(this, DryError);
    return _super3.apply(this, arguments);
  }

  (0, _createClass2.default)(DryError, [{
    key: "parse",
    value:
    /**
     * @param {WebexHttpError} reason
     * @returns {string}
     */
    function parse(reason) {
      (0, _apply.default)(_webexCore.WebexHttpError.prototype.parse, this, [reason._res]);
      var body = reason._res.body.message;
      var message = body.reason || body;

      if (!message) {
        message = this.constructor.defaultMessage;
      }

      if (this.options.url) {
        message += "\n".concat(this.options.method, " ").concat(this.options.url);
      } else if (this.options.uri) {
        message += "\n".concat(this.options.method, " ").concat(this.options.uri);
      } else {
        message += "\n".concat(this.options.method, " ").concat(this.options.service.toUpperCase(), "/").concat(this.options.resource);
      }

      message += "\nWEBEX_TRACKING_ID: ".concat(this.options.headers.trackingid);

      if (body.status) {
        message += "\nKMS_RESPONSE_STATUS: ".concat(body.status);
      }

      if (body.requestId) {
        message += "\nKMS_REQUEST_ID: ".concat(body.requestId);
      }

      (0, _defineProperties.default)(this, {
        reason: {
          enumerable: false,
          value: body.reason
        },
        requestId: {
          enumerable: false,
          value: body.requestId
        },
        status: {
          enumerable: false,
          value: body.status
        }
      });
      return message;
    }
  }]);
  return DryError;
}(_webexCore.WebexHttpError);

exports.DryError = DryError;
(0, _defineProperty2.default)(DryError, "defaultMessage", 'An unknown error was received from a service that proxies to the KMS');
//# sourceMappingURL=kms-errors.js.map
